import type { MouseEvent } from "react";
import { useCmsContent } from "@/hooks/use-cms-content";

export const WHATSAPP_URL =
  "https://web.whatsapp.com/send?phone=+351915883495&text=Thaiane, gostava de realizar um agendamento!";

export const WHATSAPP_DEFAULT_MESSAGE_PT =
  "Thaiane, gostava de realizar um agendamento!";

export const useWhatsApp = (_customMessage?: string) => {
  // Keep hook call to preserve consistent hook order across renders/HMR
  useCmsContent();

  const openWhatsApp = (event?: MouseEvent<HTMLElement>) => {
    event?.preventDefault();
    window.open(WHATSAPP_URL, "_blank", "noopener,noreferrer");
  };

  return {
    url: WHATSAPP_URL,
    digits: "351915883495",
    message: WHATSAPP_DEFAULT_MESSAGE_PT,
    enabled: true,
    open: openWhatsApp,
  };
};
